import React from "react";
import Button from "@material-ui/core/Button";
import { FaEraser, FaSave, FaSearch, FaRedo, FaArrowAltCircleDown, FaTimes } from "react-icons/fa";
import "./buttonStyle.scss";
import { ImPrinter } from "react-icons/im";

/* Author - AndréK 
    22/08/2022
*/

const DefaultButton = React.forwardRef((props, ref) => {

    //Todas Variaveis do props props
    const { visible, disabled, onClick, cancel, content, clear, search, save, reset, className, style, src, print, exportFile, labelName } = props
    //** ClassName Disponiveis para usar : primaryButton , secondaryButton ,successButton , errorButton**/

    return (
        <Button
            style={style ? style : visible ? { display: "none" } : { display: "block", opacity: disabled ? '60%' : null, }}
            ref={ref}
            fullWidth
            size="large"
            onClick={onClick}
            className={className}
            type={props.submit ? "submit" : null}
            disabled={disabled ? true : null}
        >
            {/* Caso esteja usando uma variavel : Clear  , Search ou Save , traz um icone padrão 
            , caso contrario o conteudo fica disponivel para ser preenchido */}
            {content ? content :
                clear ? (
                    <FaEraser style={{ height: "23px", width: "23px" }} />
                ) : search ? (
                    <FaSearch style={{ height: "20px", width: "20px" }} />
                ) : cancel ? (
                    <FaTimes style={{ height: "21px", width: "21px" }} />
                ) : save ? (
                    <FaSave style={{ height: "21px", width: "21px" }} />
                ) : reset ? (
                    <FaRedo style={{ height: "21px", width: "21px" }} />
                ) : exportFile ? (
                    <FaArrowAltCircleDown style={{ height: "21px", width: "21px", color: '#ffffff' }} />
                )
                    : print ? (<ImPrinter style={{ height: "21px", width: "21px" }} />)
                        : labelName ? labelName : null}
            {src && <img src={src} alt={labelName} style={{ height: "21px", width: "21px", filter: 'invert(100%)' }} />}
        </Button>
    );
});

export default DefaultButton;


//Exemplos : 


//Custom label Btn : 
{/* <DefaultButton
    onClick={releaseUser}
    content={t("releaseUser")}
    className="secondaryButton"
    /> */}


//Search Icon Button
{/*
    <DefaultButton 
    search 
    className="primaryButton" 
    onClick={onClickSearch} />
**/}